'use client'

import { Button } from '@/components/elements/Button'
import Input from '@/components/elements/Input'
import { formatImageURL } from '@/utils/util'
import { useRegisterForm } from '@/lib/commerce/hooks'

export default function Register({ vendor }: { vendor?: any }) {
  const f = useRegisterForm(vendor)

  return (
    <div className="w-full max-w-md">
      <div className="flex flex-col items-center gap-6">
        {vendor?.logo ? (
          <img src={formatImageURL(vendor?.logo)} alt="logo" className="h-8 max-w-40 w-auto object-contain" />
        ) : vendor?.name ? (
          <div className="text-xl sm:text-2xl font-bold tracking-tight">{vendor?.name}</div>
        ) : null}
        <h1 className="text-center text-foreground text-3xl font-semibold leading-7.5 tracking-[-0.7%]">Бүртгэл үүсгэх</h1>
      </div>
      <div className="mt-14">
        <div className="flex flex-col gap-4">
          <form onSubmit={f.handleRegister} className="flex flex-col gap-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Input label="Овог" placeholder="Таны овог" onChange={(e: any) => f.setLastName(e.target.value)} autoFocus />
              <Input label="Нэр" placeholder="Таны нэр" onChange={(e: any) => f.setFirstName(e.target.value)} />
            </div>
            <Input label="Имэйл хаяг" type="email" placeholder="example@shop.mn" onChange={(e: any) => f.setEmail(e.target.value)} />
            <Input label="Утасны дугаар" type="text" placeholder="00000000" onChange={(e: any) => f.setPhone(e.target.value)} />
            <Input label="Шинэ нууц үг" type="password" placeholder="Таны шинэ нууц үг" onChange={(e: any) => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" />
            <Button type="submit" isLoading={f.loading} variant="outline" className="mt-2 w-full h-10 bg-foreground text-white font-medium! border-foreground hover:bg-foreground/90 hover:text-white transition-all" loadingMessage="Бүртгүүлж байна...">
              Бүртгүүлэх
            </Button>
          </form>
          <div className="flex items-center justify-center gap-2">
            <div className="grow basis-0 border-b border-neutral-200" />
            <span className="text-sm font-medium leading-5 tracking-[-0.5%] text-muted-foreground">Эсвэл</span>
            <div className="grow basis-0 border-b border-neutral-200" />
          </div>
        </div>
      </div>
      <p className="mt-4 text-center text-foreground leading-5">
        Аль хэдийн бүртгэлтэй юу?{' '}
        <span onClick={f.routeToLogin} className="cursor-pointer font-medium text-foreground underline hover:text-foreground/90 leading-5 tracking-[-0.5%] transition-colors">
          Нэвтрэх
        </span>
      </p>
    </div>
  )
}
